import { Component, input } from '@angular/core';
import { NavigationLogo } from '@core/navigation-models';
import { AppStoreButtonsComponent } from '@core/navigation-ui';
import { NavLinkComponent } from '@core/navigation-ui/nav-link';
import { NavigationLogoComponent } from '@core/navigation-ui/navigation-logo';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import type {
  FooterAppsNavigation,
  FooterUsefulLinksNavigation,
  FooterWebNavigation,
} from './footer.models';

@Component({
  selector: 'wl-footer',
  standalone: true,
  imports: [
    FontAwesomeModule,
    NavLinkComponent,
    NavigationLogoComponent,
    AppStoreButtonsComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.ed.scss', './footer.component.essent.scss'],
})
export class FooterComponent {
  readonly appNavigation = input.required<FooterAppsNavigation>();
  readonly webNavigation = input.required<FooterWebNavigation>();
  readonly usefulLinks = input.required<FooterUsefulLinksNavigation>();
  readonly logo = input.required<NavigationLogo>();
  readonly currentYear = input.required<number>();
  readonly brandName = input.required<string>();
}
